// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper-kGQ49K"};